export type VatPercentage = 0 | 6 | 9 | 21;
export const VatPercentages: VatPercentage[] = [0, 6, 9, 21];
